// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"331":"61adc699","367":"1f9992b3","633":"8b12a70c","786":"0420d10b"}[chunkId] + ".css";
};